import { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';

import { Project } from '@cartwhl/common/types';
import useMediaQuery from '@cartwhl/ui/hooks/useMediaQuery';

import { posingStore, projectStore } from 'stores';
import { IKChainType } from 'stores/posingStore';
import { getJobIDsFromProjectTimeline } from 'stores/projectStore';

import FloatPanel from './components/FloatPanel';
import IKPanelContent from './components/IKPanelContent';
import RenderPanelContent from './components/RenderPanelContent';
import { IK_SELECTORS } from './constants';

export default function FloatPanels() {
  const { activeIKChain } = useSnapshot(posingStore.state);
  const [isIKPanelOpen, setIsIKPanelOpen] = useState(true);
  const isMobile = useMediaQuery('(max-width: 640px)');
  // default to open on desktop, closed on mobile.
  const [isRenderPanelOpen, setIsRenderPanelOpen] = useState(!isMobile);

  const activeIKChainInfo =
    activeIKChain !== IKChainType.None ? IK_SELECTORS[activeIKChain] : null;

  return (
    <>
      {activeIKChainInfo && (
        <FloatPanel
          title={activeIKChainInfo?.label}
          isOpen={isIKPanelOpen}
          setIsOpen={setIsIKPanelOpen}
          className={`transition-opacity duration-200 ease-in-out ${isRenderPanelOpen ? 'opacity-0 sm:opacity-100' : 'delay-200'}`}
        >
          <IKPanelContent />
        </FloatPanel>
      )}

      <FloatPanel
        title="Render view"
        placement="right"
        isOpen={isRenderPanelOpen}
        setIsOpen={setIsRenderPanelOpen}
        className={`transition-opacity duration-200 ease-in-out ${isIKPanelOpen && !isRenderPanelOpen ? 'opacity-0 sm:opacity-100' : 'delay-200'}`}
      >
        <RenderPanelContent />
      </FloatPanel>
    </>
  );
}
